export default __webpack_public_path__ + "static/media/IMG_3665.670a6879.jpg";